/**
 * Kauf-Aktionen für Buttons außerhalb des Produktformulars (Hero, Sticky-Leiste).
 *
 * [data-fc-add] legt über das vorhandene Produktformular in den Warenkorb.
 *   Dadurch übernimmt das Theme wie gewohnt: AJAX, Fehlermeldungen, Warenkorb-Drawer.
 * [data-fc-buy] legt in den Warenkorb und geht direkt zur Kasse.
 *
 * Ohne Produktformular auf der Seite passiert nichts; ein Link im Button greift dann normal.
 */
(function () {
  if (window.__fcBuyInit) return;
  window.__fcBuyInit = true;

  /** Das erste echte Produktformular der Seite (Kaufbereich bzw. Produktseite). */
  function productForm() {
    return document.querySelector('form[data-type="add-to-cart-form"]');
  }

  function variantId(form) {
    var input = form.querySelector('input[name="id"]');
    return input && input.value ? input.value : null;
  }

  function quantity(form) {
    var input = form.querySelector('input[name="quantity"]');
    var value = input ? parseInt(input.value, 10) : 1;
    return isFinite(value) && value > 0 ? value : 1;
  }

  function addToCart(form) {
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  }

  function buyNow(form, button) {
    var id = variantId(form);
    if (!id) {
      window.location.href = '/cart';
      return;
    }
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity(form) }] }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart/add fehlgeschlagen');
        window.location.href = '/checkout';
      })
      .catch(function () {
        button.removeAttribute('aria-busy');
        button.disabled = false;
        window.location.href = '/cart';
      });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var add = target.closest('[data-fc-add]');
    var buy = target.closest('[data-fc-buy]');
    if (!add && !buy) return;

    var form = productForm();
    if (!form) return;

    event.preventDefault();
    if (add) addToCart(form);
    else buyNow(form, buy);
  });
})();
